import _ from 'lodash';
import type { UserQuery, UserQueryVariables } from '@/shared/api';

import { createClient } from '@/shared/api';
import USER_SIGNATURE_QUERY from '../queries/userSignature';

/**
 * Loads a user's stored signature image. Runs USER_SIGNATURE_QUERY, throws the first GraphQL error message when the user field is nil, and hands back the whole Apollo result rather than the user.
 *
 * @param id - Identifier of the user whose signature is read.
 * @returns The raw Apollo query result holding the user signature.
 */
const fetchUserSignature = async (id: string) => {
  const client = createClient();
  const userResult = await client.query<UserQuery, UserQueryVariables>({
    query: USER_SIGNATURE_QUERY,
    variables: {
      id,
    },
  });
  const { data, errors } = userResult;
  const { user } = data;
  if (_.isNil(user) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return userResult;
};

export default fetchUserSignature;
